interface SectionHeaderProps {
  title: string
  description?: string | React.ReactNode
}

export const SectionHeader = ({ title, description }: SectionHeaderProps) => {
  return (
    <div className="flex flex-col gap-4 items-start w-full">
      <div className="flex flex-col gap-2 items-center w-full">
        <h2
          className="text-base lg:text-[32px] lg:font-[Hiragino_Kaku_Gothic_Std,Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
          style={{
            fontWeight: 700,
            letterSpacing: '1.28px',
            lineHeight: '1.6',
            color: '#009CD2',
            textAlign: 'center',
          }}
        >
          {title}
        </h2>
        <div
          style={{
            width: '278px',
            height: '2px',
            backgroundColor: '#009CD2',
          }}
        />
      </div>
      {description && (
        <div
          className="text-xs lg:text-base text-left lg:text-center lg:font-[Hiragino_Kaku_Gothic_Std,Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
          style={{
            fontWeight: 400,
            letterSpacing: '0.64px',
            lineHeight: '1.6',
            color: '#363636',
            width: '100%',
          }}
        >
          {description}
        </div>
      )}
    </div>
  )
}
